// extracted by mini-css-extract-plugin
module.exports = {"container":"JobAlertChip_container__4AWY5","chip":"JobAlertChip_chip__jbLeI"};